"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.config = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _internalPluginMercury = _interopRequireDefault(require("@webex/internal-plugin-mercury"));
var _constants = require("./constants");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } } /* eslint-disable consistent-return */
// eslint-disable-next-line no-unused-vars

var config = exports.config = {
  llm: {
    /**
     * Milliseconds between pings sent up the socket
     * @type {number}
     */
    pingInterval: process.env.MERCURY_PING_INTERVAL || 15000,
    /**
     * Milliseconds to wait for a pong before declaring the connection dead
     * @type {number}
     */
    pongTimeout: process.env.MERCURY_PONG_TIMEOUT || 14000,
    /**
     * Maximum milliseconds between connection attempts
     * @type {Number}
     */
    backoffTimeMax: process.env.MERCURY_BACKOFF_TIME_MAX || 32000,
    /**
     * Initial milliseconds between connection attempts
     * @type {Number}
     */
    backoffTimeReset: process.env.MERCURY_BACKOFF_TIME_RESET || 1000,
    /**
     * Milliseconds to wait for a close frame before declaring the socket dead and
     * discarding it
     * @type {[type]}
     */
    forceCloseDelay: process.env.MERCURY_FORCE_CLOSE_DELAY || 2000
  }
};

/**
 * LLMChannel to provide socket connections
 */
var LLMChannel = exports.default = /*#__PURE__*/function (_ref) {
  (0, _inherits2.default)(LLMChannel, _ref);
  var _super = _createSuper(LLMChannel);
  function LLMChannel() {
    var _this;
    (0, _classCallCheck2.default)(this, LLMChannel);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "namespace", _constants.LLM);
    /**
     * If the LLM plugin has been registered and listening
     * @instance
     * @type {Boolean}
     * @public
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "webSocketUrl", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "binding", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "locusUrl", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "datachannelUrl", void 0);
    /**
     * Register to the websocket
     * @param {string} llmSocketUrl
     * @returns {Promise<void>}
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "register", function (llmSocketUrl) {
      return _this.request({
        method: 'POST',
        url: llmSocketUrl,
        body: {
          deviceUrl: _this.webex.internal.device.url
        }
      }).then(function (res) {
        _this.webSocketUrl = res.body.webSocketUrl;
        _this.binding = res.body.binding;
      }).catch(function (error) {
        _this.logger.error("Error connecting to websocket: ".concat(error));
        throw error;
      });
    });
    /**
     * Register and connect to the websocket
     * @param {string} locusUrl
     * @param {string} datachannelUrl
     * @returns {Promise<void>}
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "registerAndConnect", function (locusUrl, datachannelUrl) {
      return _this.register(datachannelUrl).then(function () {
        if (!locusUrl || !datachannelUrl) return undefined;
        _this.locusUrl = locusUrl;
        _this.datachannelUrl = datachannelUrl;
        _this.connect(_this.webSocketUrl);
      });
    });
    /**
     * Tells if LLM socket is connected
     * @returns {boolean} connected
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isConnected", function () {
      return _this.connected;
    });
    /**
     * Tells if LLM socket is binding
     * @returns {string} binding
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getBinding", function () {
      return _this.binding;
    });
    /**
     * Get Locus URL for the connection
     * @returns {string} locus Url
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getLocusUrl", function () {
      return _this.locusUrl;
    });
    /**
     * Get data channel URL for the connection
     * @returns {string} data channel Url
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getDatachannelUrl", function () {
      return _this.datachannelUrl;
    });
    /**
     * Disconnects websocket connection
     * @returns {Promise<void>}
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "disconnectLLM", function () {
      return _this.disconnect().then(function () {
        _this.locusUrl = undefined;
        _this.datachannelUrl = undefined;
        _this.binding = undefined;
        _this.webSocketUrl = undefined;
      });
    });
    return _this;
  }
  return (0, _createClass2.default)(LLMChannel);
}(_internalPluginMercury.default);
//# sourceMappingURL=llm.js.map
